import { Controller } from "@hotwired/stimulus";

let focusedElementId = null;

// This script preserves focus between turbo navigation
export default class extends Controller {
  connect() {
    if (!window._preserveFocusListenersInit) {
      this.setupGlobalListeners();
      window._preserveFocusListenersInit = true;
    }
  }

  setupGlobalListeners() {
    document.addEventListener('turbo:before-render', () => this.saveFocus());
    document.addEventListener('turbo:render', () => this.restoreFocus());
  }

  saveFocus() {
    focusedElementId = document.activeElement?.id || null;
  }

  restoreFocus() {
    if (!focusedElementId) return;

    requestAnimationFrame(() => {
      const element = document.getElementById(focusedElementId);

      if (element) {
        element.focus();

        if (element.type === 'text') {
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }

        focusedElementId = null;
      }
    });
  }
}
